import React from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import TypeSelector from '../common/type-selector/view.tsx';
import image from './assets/repository.svg';
import messages from './messages.tsx';

type Props = {
	onAdd: () => void;
};

export default function RepositorySelector(props: Props) {
	const { onAdd } = props;
	return (
		<TypeSelector
			title={messages.title}
			description={
				fg('jira-issue-terminology-refresh-m3')
					? messages.descriptionIssueTermRefresh
					: messages.description
			}
			imageUrl={image}
			onAdd={onAdd}
		/>
	);
}
